<template>
    <tr class="itemLista hover">
        <td>{{prazoEnvio.codigo}}</td>
        <td>{{prazoEnvio.descricao}}</td>
        <td>{{prazoEnvio.prazo}}</td>
        <td>{{prazoEnvio.tipoEvento}}</td>
    </tr>    
</template>
<script>
export default {
    props: ["prazoEnvio"],
}
</script>
<style scoped>
    .tdBotao{
        width: 6em;
        vertical-align: middle; 
    }
    .itemLista{
        font-size: 90%;
    }
    .hover:hover{
        background-color: lightgrey;
    }
</style>





// WEBPACK FOOTER //
// src/components/prazoEnvioAll.vue